import React, { useContext, useState, useEffect } from "react";
import Box from '@mui/material/Box';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import api from '../../services/api';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import { Grid, Card, Input } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CardContent from '@material-ui/core/CardContent';
import Nenhum_Produto from '../Nenhum_Produto_Localizado/Nenhum_Produto_Localizado';
import TextField from '@mui/material/TextField';
import Dialogo from '../Dialogo/Dialogo';
import { MyContext } from '../../context/MyContext';
import ModalDetalhes from '../../components/Pages/PaginaProduto/ModalDetalhes';
import { BrowserView, MobileView } from 'react-device-detect';
import SemImagem from '../../../src/assets/img/sem_imagem.svg';
import { formatarTelefone, formatarDataHora, numberWithCommas, identificacaoUsuarioLogado } from '../../utils';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { red } from '@mui/material/colors';

const toastMensagemError = (message) => toast.error(message,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

function Produtos_Cards(props) {
    let navigate = useHistory();
    const { meuCarrinho, setMeuCarrinho } = useContext(MyContext);
    const { setCarrinhoCounter } = useContext(MyContext);
    const { setOpenMD } = useContext(MyContext);
    const [codigoClicado, setCodigoClicado] = useState(null);
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    const { destinoPagina, setDestinoPagina } = useContext(MyContext);
    const [ listaProdutos, setListaProdutos ] = useState(null);
    const [openDialogo, setOpenDialogo] = useState(false);
    const [dialogoMensagem, SetDialogoMensagem] = useState("");
    const [dialogoRetornoSim, setDialogoRetornoSim] = useState(false);
    const [dialogoProduto, setDialogoProduto] = useState({});
    let _props = Object.values(props);
    let _quantItens = (_props[0] == null ? 0 : _props[0]?.amount);
    let itemQuantidade = 0;  // Lixo

    useEffect(() => {
        if (props?.produtos?.produtos != undefined){
            setListaProdutos(props?.produtos?.produtos);
        }
    }, []);

    const handleCloseNao = () => {
        setDialogoProduto({});
        setDialogoRetornoSim(false);
        setOpenDialogo(false);
    };

    const handleCloseSim = () => {        
        setDialogoRetornoSim(true);
        favoritarItem(dialogoProduto);
        setOpenDialogo(false);
    };
    
    const handleClickOpen = (produto) => {
        if (produto.favoritado == 1){
            SetDialogoMensagem(produto.codigo + " - " + produto.descricao + "?");
            setDialogoProduto(produto);
            setOpenDialogo(true);
        }
        else{
            favoritarItem(produto);
        }       
    };


    const abrirPaginaModalDetalhes = (e) => {
        setCodigoClicado(e);
        setOpenMD(true);
    };

    const favoritarItem = (prod) => {
        setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
        var userLogado = identificacaoUsuarioLogado(usuarioLogado);
        if (userLogado != null && userLogado.length == 0) {
            toastMensagemError("Será Necessário Efetuar Login!");
            setDestinoPagina("produtos");
            navigate.push('/login');
        }
        else {
            const favoritar = {
                "cliente_id": userLogado.split('_')[0],
                "cliente_loja": userLogado.split('_')[1],
                "produto_id": prod.codigo
            };

            api.post(`/Produtos/Favoritar`, favoritar)
                .then((response) => {                    
                    prod.favoritado = (response.data == true ? 1 : 0);
                    setListaProdutos(listaProdutos.map(prodx =>
                         prodx.codigo === prod.codigo ? { ...prodx, favoritado: (response.data == true ? 1 : 0) } : prodx
                    ));
                    return response;
                })
                .catch((error) => {
                    toastMensagemError("Falha ao Incluir nos Favoritos!");
                    prod.favoritado = 0;
                });
        }
    };

    function AdicionarCarrinho(event, produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        if (jaExiste) {
            jaExiste.quantidade += 1;
            if (jaExiste.quantidade > produto.quantidadedisponivel) {
                jaExiste.quantidade = produto.quantidadedisponivel
            }
            let _novaQuantidade = meuCarrinho.slice(jaExiste);
            setMeuCarrinho(_novaQuantidade)
            window.setCookie("nafil_carrinho", JSON.stringify(_novaQuantidade), 31);
            AtualizarContadorCarrinho(_novaQuantidade);
        } else {
            if (meuCarrinho.length === 0) {
                produto.quantidade = 1;
                setMeuCarrinho([produto]);
                window.setCookie("nafil_carrinho", JSON.stringify([produto]), 31);
                AtualizarContadorCarrinho([produto]);
            }
            else {
                produto.quantidade = 1;
                const novaArray = [...meuCarrinho, produto];
                setMeuCarrinho(novaArray);
                window.setCookie("nafil_carrinho", JSON.stringify(novaArray), 31);
                AtualizarContadorCarrinho(novaArray);
            }
        }
    }

    function RemoverCarrinho(event, produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        if (jaExiste) {
            jaExiste.quantidade -= 1;
            if (jaExiste.quantidade <= 0) {
                jaExiste.quantidade = 0;
                let novoCarrinho = meuCarrinho.slice(jaExiste)
                setMeuCarrinho(novoCarrinho);
                window.setCookie("nafil_carrinho", JSON.stringify(novoCarrinho), 31);
                AtualizarContadorCarrinho(novoCarrinho);
            }
            else {
                setMeuCarrinho(meuCarrinho);
                window.setCookie("nafil_carrinho", JSON.stringify(meuCarrinho), 31);
                AtualizarContadorCarrinho(meuCarrinho);
            }
        }
    }

    function handleChange(e, produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        if (jaExiste) {
            jaExiste.quantidade = e.target.value;
            if (jaExiste.quantidade > produto.quantidadedisponivel) {
                jaExiste.quantidade = produto.quantidadedisponivel
            }
            setMeuCarrinho(meuCarrinho.slice(jaExiste))
        }
        window.setCookie("nafil_carrinho", JSON.stringify(meuCarrinho), 31);
        AtualizarContadorCarrinho();
    }

    function AtualizarContadorCarrinho(_meuCarrinho) {
        let _NumeroProdutosSelecionados = 0;
        _meuCarrinho.map((prod) => {
            _NumeroProdutosSelecionados += Number(prod.quantidade);
        });
        setCarrinhoCounter(_NumeroProdutosSelecionados ?? 0);
    }


    function AviseMe(event, produto) {

    }

    return (
        <div>
            <BrowserView>
                <Grid container gap={1} marginTop={'12px'}>
                    {
                        _quantItens == 0 ? <Nenhum_Produto /> :

                            listaProdutos?.map((prod) => {

                                let jaExiste = meuCarrinho.find(function (jaExiste) {
                                    return jaExiste.codigo == prod.codigo
                                })
                                if (jaExiste) {
                                    prod.quantidade = jaExiste.quantidade;
                                }

                                return (
                                    <Grid direction="column" justifyContent="space-between" spacing={1} columns={{ xs: 12, sm: 8, md: 4 }} sx={{ display: 'flex-end', flexDirection: 'row', justifyContent: 'flex-end', minWidth: 260, minHeight: 420, maxWidth: 260, maxHeight: 420, marginBottom: '10px', height: '100%', paddingLeft: '5px' }}>
                                        <Grid item xs={6} style={{ display: 'flex', minHeight: '400px' }}>
                                            <Card id={"PROD_" + prod.codigo} name={"PROD_" + prod.codigo} sx={{ bgcolor: '#F5F5F5', minHeight: '430px', maxHeight: '430px', minWidth: '255px' }}>
                                                <Box sx={{ minHeight: '240px', maxHeight: '240px', display: 'flex', alignItems: 'center' }}>
                                                    <CardMedia
                                                        key={"PROD_" + prod.codigo}
                                                        id={"PROD_" + prod.codigo}
                                                        component="img"
                                                        image={prod.caminho_imagem}
                                                        alt={prod.descricao}
                                                        sx={{ height: 'auto', width: 'auto', margin: 'auto', maxHeight: '240px', maxWidth: '210px', padding: '10px' }}
                                                    />
                                                </Box>

                                                <CardContent>
                                                    <Grid container variant="body2" direction="row" justify="space-between">
                                                        <Grid item xs={12} textAlign={"left"} sx={{ marginTop: '-40px', minHeight: '80px', height: '80px' }}>
                                                            <Typography>
                                                                <h5>{prod.descricao}</h5>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={4} textAlign={"left"} color="text.secondary" sx={{ marginTop: '-20px' }}>
                                                            <h9>ID: {prod.codigo}</h9>
                                                        </Grid>
                                                        <Grid item xs={8} textAlign={"right"} color="text.secondary" sx={{ marginTop: '-20px' }}>
                                                            <h9>{prod.n_original}</h9>
                                                        </Grid>
                                                    </Grid>
                                                    <Typography variant="body2" color="text.secondary">
                                                        <Grid container textAlign={"right"}>
                                                            <Grid item xs={12}>
                                                                <h9><b>{prod.id_marcaNavigation.descricao}</b></h9>
                                                            </Grid>
                                                        </Grid>


                                                        <Grid container direction="row" justify="space-between">
                                                            <Grid item xs={6.5} sx={{ marginTop: '-5px', textAlign: "left" }}>
                                                                <Rating name="read-only" value={prod.rank} readOnly />
                                                            </Grid>
                                                            <Grid item xs={2} alignContent={'left'} alignItems={'left'} alignSelf={'left'} >
                                                                <Typography gutterBottom sx={{ fontSize: '10px', marginTop: '-1px' }}>({prod.rankVotes})</Typography>
                                                            </Grid>
                                                            <Grid item xs={3.5}>
                                                                <Typography gutterBottom sx={{ fontSize: '12px', color: 'red', marginTop: '4px', marginLeft: '20px' }}>À Vista</Typography>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container>
                                                            <Grid item xs={2.5} >
                                                                <ShareIcon />
                                                            </Grid>
                                                            <Grid item xs={2.5}>
                                                                <FavoriteIcon style={{ color: prod.favoritado == 1 ? red[500] : 'inherit', cursor: 'pointer' }} onClick={(event) => handleClickOpen(prod)} />
                                                            </Grid>
                                                            <Grid item xs={7} display="flex" justifyContent="flex-end" sx={{ marginTop: '-30px' }}>
                                                                <h2 style={{ color: 'red', fontSize: '24px', marginTop: '27    px' }}>{prod.a_vista.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h2>
                                                            </Grid>
                                                        </Grid>
                                                    </Typography>
                                                </CardContent>

                                                <CardActions sx={{ marginTop: '-25px' }}>
                                                    <Grid container sx={{ display: 'flex', flex: 1, alignItems: 'flex-end', justifyContent: 'center' }}>
                                                        <Grid item direction="row" justifyContent="space-between" alignItems="center" sx={{ display: 'flex', flex: '1 0 auto', alignItems: 'flex-end', justifyContent: 'center' }} xs={6}>
                                                            <Button size="small" onClick={(e) => abrirPaginaModalDetalhes(prod)} variant='contained' startIcon={<MenuBookIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Detalhes</Button>
                                                            {/* <ModalDetalhes id={"MD_" + prod.codigo} props={prod} /> */}

                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <div class="cart-totals">
                                                                {
                                                                    (prod?.quantidade > 0
                                                                        ?
                                                                        <Box sx={{ display: "flex", flex: 1, alignContent: "center", textAlign: "center", border: 1, borderRadius: 1, borderColor: "#ccc", height: '30px' }}>
                                                                            <IconButton name="Remover" onClick={event => RemoverCarrinho(event, prod)}>
                                                                                <RemoveIcon fontSize="small" sx={{ marginTop: '5px', marginLeft: '1px' }} />
                                                                            </IconButton>

                                                                            <Box width={47}>
                                                                                <TextField
                                                                                    hiddenLabel
                                                                                    type="tel"
                                                                                    name={"ITEM_" + prod.codigo} id={"ITEM_" + prod.codigo}
                                                                                    value={prod.quantidade}
                                                                                    //defaultValue="Small"  
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    inputProps={{ min: 0, style: { textAlign: 'center', paddingLeft: '1px', paddingRight: '1px' } }}
                                                                                    sx={{ display: 'flex', textAlign: 'left', marginTop: '-4px', padding: '1px', minWidth: '45px', "& fieldset": { border: 'none', } }}
                                                                                    onChange={(event) => { handleChange(event, prod); }}
                                                                                />
                                                                            </Box>

                                                                            <IconButton name="Adicionar" onClick={event => AdicionarCarrinho(event, prod)}>
                                                                                <AddIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                                                            </IconButton>
                                                                        </Box>
                                                                        :
                                                                        (
                                                                            prod.quantidadedisponivel <= 0
                                                                                ?
                                                                                <Button size="small" variant='contained' id={prod.codigo} value={prod.codigo} onClick={event => AviseMe(event, prod)} startIcon={<AddAlertIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Avise-me</Button>
                                                                                :
                                                                                <Button size="small" variant='contained' id={prod.codigo} value={prod.codigo} onClick={event => AdicionarCarrinho(event, prod)} startIcon={<AddShoppingCartIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Comprar</Button>
                                                                        )
                                                                    )
                                                                }
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                </Grid>
            </BrowserView>

            <MobileView>
                <Grid container gap={1} marginTop={'12px'}>
                    {
                        _quantItens == 0 ? <Nenhum_Produto /> :

                            props?.produtos?.produtos?.map((prod) => {

                                let jaExiste = meuCarrinho.find(function (jaExiste) {
                                    return jaExiste.codigo == prod.codigo
                                })
                                if (jaExiste) {
                                    prod.quantidade = jaExiste.quantidade;
                                }
                                // let _minhaImagem = checkImageExists("https://whats.nafil.com.br/figuras_produtos/" + prod.codigo.toString().substr(0, 1) + "/" + prod.codigo.toString() + ".jpg");    
                                // console.log("X => " + _minhaImagem);
                                ///setImageEndereco(_minhaImagem);


                                return (
                                    <Grid direction="column" justifyContent="space-between" spacing={2} minWidth={'100%'} display={'flex'} paddingRight={'13px'}>
                                        <Grid item xs={12} width={'100%'}>

                                            <Card id={"PROD_" + prod.codigo} name={"PROD_" + prod.codigo} sx={{ bgcolor: '#F5F5F5', minHeight: '430px', minWidth: '90%' }}>
                                                <Box sx={{ minHeight: '240px', display: 'flex', alignItems: 'center' }}>
                                                    <CardMedia
                                                        key={"PROD_" + prod.codigo}
                                                        id={"PROD_" + prod.codigo}
                                                        component="img"
                                                        image={prod.caminho_imagem}
                                                        alt={prod.descricao}
                                                        sx={{ height: 'auto', width: 'auto', margin: 'auto', maxHeight: '210px', maxWidth: '210px', padding: '10px' }}
                                                    />
                                                </Box>

                                                <CardContent>
                                                    <Grid container variant="body2" direction="row" justify="space-between">
                                                        <Grid item xs={12} textAlign={"left"} sx={{ marginTop: '-40px', minHeight: '80px', height: '80px' }}>
                                                            <Typography>
                                                                <h5>{prod.descricao}</h5>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={4} textAlign={"left"} color="text.secondary" sx={{ marginTop: '-20px' }}>
                                                            <h9>ID: {prod.codigo}</h9>
                                                        </Grid>
                                                        <Grid item xs={8} textAlign={"right"} color="text.secondary" sx={{ marginTop: '-20px' }}>
                                                            <h9>{prod.n_original}</h9>
                                                        </Grid>
                                                    </Grid>
                                                    <Typography variant="body2" color="text.secondary">
                                                        <Grid container textAlign={"right"}>
                                                            <Grid item xs={12}>
                                                                <h9><b>{prod.id_marcaNavigation.descricao}</b></h9>
                                                            </Grid>
                                                        </Grid>


                                                        <Grid container direction="row" justify="space-between">
                                                            <Grid item xs={6.5} sx={{ marginTop: '-5px', textAlign: "left" }}>
                                                                <Rating name="read-only" value={prod.rank} readOnly />
                                                            </Grid>
                                                            <Grid item xs={2} alignContent={'left'} alignItems={'left'} alignSelf={'left'} >
                                                                <Typography gutterBottom sx={{ fontSize: '10px', marginTop: '-1px' }}>({prod.rankVotes})</Typography>
                                                            </Grid>
                                                            <Grid item xs={3.5}>
                                                                <Typography gutterBottom sx={{ fontSize: '12px', color: 'red', marginTop: '4px', marginLeft: '20px' }}>À Vista</Typography>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container>
                                                            <Grid item xs={2.5} >
                                                                <ShareIcon />
                                                            </Grid>
                                                            <Grid item xs={2.5}>
                                                                <FavoriteIcon style={{ color: prod.favoritado == 1 ? red[500] : 'inherit', cursor: 'pointer' }} onClick={(event) => handleClickOpen(prod)} />
                                                            </Grid>
                                                            <Grid item xs={7} display="flex" justifyContent="flex-end" sx={{ marginTop: '-30px' }}>
                                                                <h2 style={{ color: 'red', fontSize: '24px', marginTop: '27    px' }}>{prod.a_vista.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h2>
                                                            </Grid>
                                                        </Grid>
                                                    </Typography>
                                                </CardContent>

                                                <CardActions sx={{ marginTop: '-25px' }}>
                                                    <Grid container sx={{ display: 'flex', flex: 1, alignItems: 'flex-end', justifyContent: 'center' }}>
                                                        <Grid item direction="row" justifyContent="space-between" alignItems="center" sx={{ display: 'flex', flex: '1 0 auto', alignItems: 'flex-end', justifyContent: 'center' }} xs={6}>
                                                            <Button size="small" onClick={(e) => abrirPaginaModalDetalhes(prod)} variant='contained' startIcon={<MenuBookIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Detalhes</Button>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <div class="cart-totals">
                                                                {
                                                                    (prod?.quantidade > 0
                                                                        ?
                                                                        <Box sx={{ display: "flex", flex: 1, alignContent: "center", textAlign: "center", border: 1, borderRadius: 1, borderColor: "#ccc", height: '30px' }} marginRight={'30px'} marginLeft={'20px'}>
                                                                            <IconButton name="Remover" onClick={event => RemoverCarrinho(event, prod)}>
                                                                                <RemoveIcon fontSize="small" sx={{ marginTop: '5px', marginLeft: '1px' }} />
                                                                            </IconButton>

                                                                            {/* <Input name={prod.codigo} id={prod.codigo} value={prod.quantidade} inputProps={{ min: 0, style: { textAlign: 'center' } }}
										disableUnderline={true} /> */}
                                                                            <Box width={47}>
                                                                                <TextField
                                                                                    hiddenLabel
                                                                                    type="tel"
                                                                                    name={"ITEM_" + prod.codigo} id={"ITEM_" + prod.codigo}
                                                                                    value={prod.quantidade}
                                                                                    //defaultValue="Small"  
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    inputProps={{ min: 0, style: { textAlign: 'center', paddingLeft: '1px', paddingRight: '1px' } }}
                                                                                    sx={{ display: 'flex', textAlign: 'left', marginTop: '-4px', padding: '1px', minWidth: '45px', "& fieldset": { border: 'none', } }}
                                                                                    onChange={(event) => { handleChange(event, prod); }}
                                                                                />
                                                                            </Box>

                                                                            <IconButton name="Adicionar" onClick={event => AdicionarCarrinho(event, prod)}>
                                                                                <AddIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                                                            </IconButton>
                                                                        </Box>
                                                                        :
                                                                        (
                                                                            prod.quantidadedisponivel <= 0
                                                                                ?
                                                                                <Button size="small" variant='contained' id={prod.codigo} value={prod.codigo} onClick={event => AviseMe(event, prod)} startIcon={<AddAlertIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Avise-me</Button>
                                                                                :
                                                                                <Button size="small" variant='contained' id={prod.codigo} value={prod.codigo} onClick={event => AdicionarCarrinho(event, prod)} startIcon={<AddShoppingCartIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Comprar</Button>
                                                                        )
                                                                    )
                                                                }
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                </Grid>
            </MobileView>

            {
                (
                    codigoClicado == null
                        ?
                        <></>
                        :
                        <ModalDetalhes props={codigoClicado} />
                )            
            }

            {
                (
                    openDialogo ?
                        <Dialogo
                            cabecalho="Deseja Excluir dos Favoritos"
                            mensagem={dialogoMensagem}
                            open={openDialogo}
                            handleCloseNao={handleCloseNao.bind(this)}
                            handleCloseSim={handleCloseSim.bind(this)}
                        />
                        : <div></div>
                )
            }


        </div>
    );
}
export default Produtos_Cards;